<script>
    import {FormFeedback, Input, InputGroup, InputGroupText} from "sveltestrap";
    import Fa from "svelte-fa";
    import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";

    export let pw;
    export let showPwLabel = 'Passwort anzeigen';
    export let hidePwLabel = 'Passwort verbergen';
    export let formFeedback = 'Falsches Passwort.';

    let type = 'password';
    let plaintext = false;

    function togglePwReveal() {
        plaintext = !plaintext;
        type = plaintext ? 'text' : 'password';
        setTimeout(() => {
            jQuery(this).closest('.input-password').find('input').focus();
        }, 100);
    }
</script>

<InputGroup class="input-password">
    <Input {...{type}} bind:value={pw} {...$$restProps} />
    <InputGroupText title="{plaintext ? hidePwLabel : showPwLabel}">
        <button
            type="button"
            class="password-visibility-toggle"
            data-test-name="password-visibility-toggle"
            on:click={togglePwReveal}
        >
            <Fa icon="{plaintext ? faEyeSlash : faEye}" />
        </button>
    </InputGroupText>
    <FormFeedback class="feedback">{formFeedback}</FormFeedback>
</InputGroup>

<style>
    :global(.input-password .feedback) {
        text-align: left;
        display: block;
        visibility: hidden;
    }

    :global(.input-password .is-invalid~.invalid-feedback) {
        visibility: initial;
    }

    :global(.input-password input, .input-password input:focus) {
        background-color: var(--brak-greyed-white);
    }

    .password-visibility-toggle {
        border: none;
        background-color: var(--bs-color-bg);
    }
</style>

